"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f448 = void 0;
exports.f448 = {
    "ǀgwi": [
        2849
    ],
    "ǀgui": [
        2849
    ],
    "ǀanda": [
        3003
    ],
    "ǀhua": [
        3073
    ],
    "ǀhû": [
        3073
    ],
    "ǀaikwe": [
        5460
    ],
    "ǀxam": [
        8400
    ],
    "ǀkamka!e": [
        8400
    ],
    "ǀkham-ka-!k’e": [
        8400
    ],
    "ǀxam-ka-!k’e": [
        8400
    ]
};
